import { render, staticRenderFns } from "./ItemEditor.vue?vue&type=template&id=0d25a148"
import script from "./ItemEditor.vue?vue&type=script&lang=ts"
export * from "./ItemEditor.vue?vue&type=script&lang=ts"
import style0 from "./ItemEditor.vue?vue&type=style&index=0&id=0d25a148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports